<template>
  <div>
    <el-form-item
      class="custom-label__input width25"
      label="Danh sách cán bộ"
      prop="flightUserList"
    >
      <div class="flex-row flex__left">
        <el-button class="btnPlain" @click="addUsers">
          <i class="fas fa-plus-circle"></i>
          Thêm cán bộ
        </el-button>
      </div>
    </el-form-item>
    <div class="form-input">
      <el-table
        class="table detailRelatedDocs"
        :data="users"
        v-if="users && users.length"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-row :gutter="24">

              <hc-maybay-user-route-extend-info-item
                fieldTitle="Giới tính"
                :value="getGenderLabel(props.row.gender)"
              ></hc-maybay-user-route-extend-info-item>

              <hc-maybay-user-route-extend-info-item
                fieldTitle="Email"
                :value="props.row.email"
              ></hc-maybay-user-route-extend-info-item>

              <hc-maybay-user-route-extend-info-item
                fieldTitle="Thẻ bông sen vàng"
                :value="props.row.bsvNumber"
              ></hc-maybay-user-route-extend-info-item>

              <hc-maybay-user-route-extend-info-item
                fieldTitle="Chức danh"
                :value="`${getPositionLabel(props.row.positionId) || '-'} - ${getDeptName(props.row.deptId) || '-'}`"
              ></hc-maybay-user-route-extend-info-item>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column width="40" type="index">
          <template #header
          >#
          </template>
        </el-table-column>

        <el-table-column
          label="Họ tên"
          show-overflow-tooltip
          property="userName"
        >
        </el-table-column>

        <el-table-column
          label="Số điện thoại"
          show-overflow-tooltip
          property="isdn"
        >
        </el-table-column>

        <el-table-column
          label="Hộ chiếu/CMTND"
          show-overflow-tooltip
          property="identityNumber"
        >
        </el-table-column>

        <el-table-column
          label="Ngày sinh"
          show-overflow-tooltip
          property="birthday"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{
                scope.row.birthday
                  | dateFormatter({
                  dateFormat: "DD/MM/YYYY",
                  nullValue: "-"
                })
              }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" header-align="left" width="80">
          <template slot-scope="scope">
            <el-tooltip placement="top" content="Sửa">
              <i
                class="el-icon-edit font-size__large color__blue clickable"
                @click="edit(scope.row)"
              ></i>
            </el-tooltip>
            <el-tooltip placement="top" content="Xóa">
              <i
                class="el-icon-circle-close font-size__large color__red clickable"
                @click="removeUsers(scope.row)"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <hc-maybay-add-user-dialog
      v-if="isEnableDialogAdd"
      :isOpen="isOpenDialogAdd"
      :user="selectedUser"
      @closeDialog="isOpenDialogAdd = false"
      @dialogClosed="isEnableDialogAdd = false"
      @submit="addUser"
    ></hc-maybay-add-user-dialog>
  </div>
</template>

<script>
import FileTypeImage from "../../job/FileTypeImage";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import HcMaybayAddUserDialog from "./hc-maybay-add-user-dialog";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import hcCfgPositionService from "../../../services/maybay/hcCfgPositionService";
import departmentService from "../../../services/departmentService";
import h from "../../../services/h";
import dateFormatter from "../../../filters/dateFormatter";
import HcMaybayUserRouteExtendInfoItem from "./hc-maybay-user-route-extend-info-item";

export default {
  name: "hc-maybay-users",
  mixins: [handleRequestErrorMixin],
  filters: {dateFormatter},
  components: {HcMaybayUserRouteExtendInfoItem, HcMaybayAddUserDialog, FileTypeImage},
  props: ["objectId", "objectType", "deptId"],

  data() {
    return {
      users: [],
      isOpenDialogAdd: false,
      isEnableDialogAdd: false,
      positions: null,
      departments: null,
      selectedUser: null
    };
  },

  watch: {
    isOpenDialogAdd(newValue) {
      if (newValue) this.isEnableDialogAdd = newValue;
      else if (this.selectedUser) this.selectedUser = null;
    }
  },

  created() {
    this.loadPositionOptions();
    this.loadDepartments();
    this.reloadData();
  },

  methods: {
    getData() {
      return this.users;
    },

    loadPositionOptions() {
      return hcCfgPositionService
        .findAll()
        .then(response => (this.positions = response.data));
    },

    loadDepartments() {
      return departmentService.findAllForHcMayBay().then(response => {
        this.departments = response.data;
      });
    },

    getGenderLabel(gender) {
      return hanhChinhUtils.getHcGenderLabel(gender);
    },

    getPositionLabel(position) {
      let positionOption = h.find(this.positions, item => item.id === position);
      return positionOption ? positionOption.positionName : null;
    },

    getDeptName(departmentId) {
      let department = h.find(
        this.departments,
        item => item.id === departmentId
      );
      return department ? department.deptName : null;
    },

    addUser(event) {
      let user = event.result;
      !this.selectedUser
        ? this.users.push(event.result)
        : this.bindDataToForm(this.selectedUser, user);
      this.isOpenDialogAdd = false;
    },

    bindDataToForm(form, user) {
      form.userName = user.userName;
      form.gender = user.gender;
      form.isdn = user.isdn;
      form.email = user.email;
      form.identityNumber = user.identityNumber;
      form.birthday = user.birthday
      form.positionId = user.positionId;
      form.deptId = user.deptId;
      form.bsvNumber = user.bsvNumber;
    },

    removeUsers(user) {
      this.users.splice(this.users.indexOf(user), 1);
    },

    edit(user) {
      this.selectedUser = user;
      this.isOpenDialogAdd = true;
    },

    reloadData() {
    },

    addUsers() {
      this.isOpenDialogAdd = true;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-users.vue